export const DOT_SIZE = 24;
export const DOT_ICON_SIZE = 16;
export const DOT_MARGIN_FROM_NODE = 6;
export const DOT_RIGHT_PADDING = 8;
